module.exports = __webpack_public_path__ + "static/vegas1-8bfaf23dddcb1a910ecac8891185fdd1.png";